import { TextField as MuiTextField, styled } from '@mui/material';

const TextField = styled(MuiTextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.shape.borderRadius,

    '& input': {
      color: theme.palette.grey[900],
      fillColor: 'inherit',
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: theme.shape.borderRadius,
      borderColor: theme.palette.grey[100],
    },
  },
}));

export default TextField;
